import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useLang } from "@/context/LanguageContext";
import { useContent } from "@/context/ContentContext";

export const Footer = () => {
  const { t } = useLang();
  const { content, posts } = useContent();
  const c = content?.contact || {};
  return (
    <footer className="bg-[#191713] text-[#F7F3EC] border-t border-[#B8933F]/15" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo size="lg" />
          <p className="mt-5 text-sm text-[#9A9184] max-w-sm leading-relaxed">{t.footer.tagline}</p>
          <div className="mt-5 space-y-1.5 text-sm text-[#9A9184]">
            {c.email && <p><a href={`mailto:${c.email}`} className="hover:text-[#B8933F] transition-colors">{c.email}</a></p>}
            {c.phone && <p><a href={`tel:${c.phone}`} className="hover:text-[#B8933F] transition-colors">{c.phone}</a></p>}
            {c.address && <p>{c.address}</p>}
            <div className="flex gap-4 pt-1">
              {c.instagram && <a href={c.instagram} target="_blank" rel="noreferrer" className="hover:text-[#B8933F] transition-colors">Instagram</a>}
              {c.linkedin && <a href={c.linkedin} target="_blank" rel="noreferrer" className="hover:text-[#B8933F] transition-colors">LinkedIn</a>}
            </div>
          </div>
        </div>
        <div className="md:col-span-3">
          <p className="text-[0.65rem] tracking-[0.25em] uppercase text-[#B8933F] font-semibold mb-4">{t.footer.nav}</p>
          <ul className="space-y-2.5 text-sm text-[#F7F3EC]/75">
            <li><Link to="/pricing" className="hover:text-[#B8933F] transition-colors">{t.nav.pricing}</Link></li>
            {posts?.length > 0 && <li><Link to="/blog" data-testid="footer-blog-link" className="hover:text-[#B8933F] transition-colors">{t.nav.blog}</Link></li>}
            <li><Link to="/contact" className="hover:text-[#B8933F] transition-colors">{t.nav.contact}</Link></li>
            <li><Link to="/portal/login" data-testid="footer-portal-link" className="hover:text-[#B8933F] transition-colors">{t.footer.portal}</Link></li>
            <li><Link to="/admin/login" data-testid="footer-admin-link" className="text-[#9A9184]/60 hover:text-[#B8933F] transition-colors">{t.nav.admin}</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="text-[0.65rem] tracking-[0.25em] uppercase text-[#B8933F] font-semibold mb-4">{t.footer.legalTitle}</p>
          <p className="text-xs text-[#9A9184] leading-relaxed">{t.footer.legal}</p>
        </div>
      </div>
      <div className="border-t border-[#F7F3EC]/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-[#9A9184]">
          <span>© {new Date().getFullYear()} Bezalel Visionary. {t.footer.rights}</span>
          <span>Dubai · Sharjah · Deira · UAE</span>
        </div>
      </div>
    </footer>
  );
};
